import { device, message } from '@homemaster/jslib'
import * as ww from '@wecom/jssdk'
import { useEffect, useState } from 'react'
import { ChatView } from './ChatView'
import MainWindow from './MainWindow'

function AppMain() {
  const [view, setView] = useState<'normal' | 'chat'>()

  useEffect(() => {
    message.init()
  }, [])

  useEffect(() => {
    ;(async () => {
      if (device.getType() === 'wxwork') {
        const context = await ww.getContext()
        if (
          ['single_chat_tools', 'single_kf_tools', 'group_chat_tools'].includes(
            context.entry,
          )
        ) {
          setView('chat')
          return
        }
      }
      setView('normal')
    })()
  }, [])

  if (!view) return null

  return view === 'chat' ? <ChatView /> : <MainWindow />
}

export default AppMain
